import { FieldSelectOption } from "@/core/types/types";
import { fetchWithTimeout, processApiResponse } from "@/core/utils";

const countriesApi = {
  getCountries: async (): Promise<{
    countries: FieldSelectOption[];
  }> => {
    const response: Response = await fetchWithTimeout(
      `api/getAlternativeCountries`,
      {
        "Content-Type": "application/json",
        method: "GET",
      }
    );
    return processApiResponse(response);
  },
};

export { countriesApi };
